import React from 'react';
import { Icon } from '../../../components/ui/index';
import { Button } from '@cotera/client/v0/components/ui/button';
import { AddCreditsAction } from '../../etc/add-credits.action';
import { useAction } from '@cotera/client/v0/actions/framework';
import { CocoEvent, useTracking } from '@cotera/client/app/etc';

export const CocoOutOfCreditsBanner: React.FC = () => {
  const addCreditsAction = useAction(AddCreditsAction);

  useTracking(CocoEvent.OutOfCreditsBannerShown, {});

  return (
    <div className="flex items-center justify-between w-full">
      <div className="flex items-center justify-start gap-2">
        <Icon icon="credit-card" className="size-4 shrink-0 text-red-500" />
        <span className="text-sm text-red-500">
          You're out of credits, top up to keep chatting!
        </span>
      </div>
      <Button
        variant="default"
        size="default"
        onClick={async () => {
          await addCreditsAction.execute();
        }}
      >
        Add Credits
      </Button>
    </div>
  );
};
